import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appOnlyNumericRatio]',
})
export class OnlyNumericRatioDirective {
  constructor(
    public element: ElementRef,
    private control: NgControl
  ) {}

  @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
    const input = this.element.nativeElement as HTMLInputElement;
    const regex = /^[0-9]{1,2}(:[0-9]{0,2})?$/;

    const value = input.value.trimStart();
    if (!regex.test(value)) {
      let newValue = value.replace(/[^0-9:]/g, '');

      // Prevent colon at the first character
      if (newValue.startsWith(':')) {
        newValue = newValue.substring(1);
      }

      // Auto-insert colon after 2 digits if it's not already there
      if (!newValue.includes(':') && newValue.length >= 2) {
        newValue = value.slice(0, 2) + ':' + newValue.slice(2);
      }

      // Ensure only one colon is present
      const firstColonIndex = newValue.indexOf(':');
      if (firstColonIndex !== -1) {
        const beforeColon = newValue.slice(0, firstColonIndex).slice(0, 2);
        const afterColonPart = newValue
          .slice(firstColonIndex + 1)
          .replace(/:/g, '') // remove extra colons
          .slice(0, 2); // limit to 2 digits
        newValue = `${beforeColon}:${afterColonPart}`;
      } else {
        newValue = newValue.slice(0, 2); // limit to 2 digits before colon
      }

      this.control.control?.setValue(newValue); //
    }
  }
}
